_ = require 'underscore'


filterByKeys = (limits, keys) ->
  if !limits?
    return []

  keys.map (key) ->
    [model, limitType] = key.split('.')
    result = limits[model]?[limitType]
    if result?.status?
      return _.extend({ key: key }, _.pick(result, 'status', 'count'))
    return
  .filter (result) -> result?

statusToSeverity = {
  maxExceeded: 0,
  disabled: 1,
  warn: 2,
  ok: 3
}

sort = (limits) ->
  _.sortBy limits, (l) ->
    statusToSeverity[l.status]

module.exports = { filterByKeys, sort }


// WEBPACK FOOTER //
// ./app/scripts/lib/limits.coffee